"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
const categorical_chart_report_model_1 = require("./categorical-chart-report.model");
const categorical_chart_options_model_1 = require("./categorical-chart-options.model");
const Subject_1 = require("rxjs/Subject");
/**
 * Created by mariam.melkonyan on 5/18/17.
 */
class CategoricalChartModel {
    constructor(chartOptions, chartReportModel, filter) {
        this.categoricalChartModel = new Subject_1.Subject();
        this._pages = [];
        this._categoricalChartOptions = chartOptions;
        this._categoricalChartReportModel = chartReportModel || new categorical_chart_report_model_1.CategoricalChartReportModel();
        this._filter = filter || idm_reporting_service_client_js_1.FilterDtoBuilder.createOrFilterBuilder().build();
    }
    getCategoricalChartReportModel() {
        return this.categoricalChartReportModel;
    }
    getCategoricalChartOptions() {
        return this.categoricalChartOptions;
    }
    getFilter() {
        return this.filter;
    }
    get categoricalChartOptions() {
        return this._categoricalChartOptions;
    }
    set categoricalChartOptions(value) {
        this._categoricalChartOptions = value;
    }
    get filter() {
        return this._filter;
    }
    set filter(value) {
        this._filter = value;
        this.categoricalChartModel.next();
    }
    get categoricalChartReportModel() {
        return this._categoricalChartReportModel;
    }
    set categoricalChartReportModel(value) {
        this._categoricalChartReportModel = value;
    }
    get pages() {
        return this._pages;
    }
    set pages(value) {
        this._pages = value;
        this.categoricalChartModel.next();
    }
    /**
     * Serializes the chart report model to json object
     * @returns {any}
     */
    serialize(languages) {
        let jsonObject = {};
        jsonObject.categoricalChartReportModel = this.categoricalChartReportModel.serialize();
        jsonObject.categoricalChartOptions = this.categoricalChartOptions.serialize(languages);
        jsonObject.filter = this._filter.toJson();
        jsonObject.version = CategoricalChartModel.version;
        jsonObject.pages = this._pages;
        return jsonObject;
    }
    /**
     * Deserializes the categorical chart model from json object and emits change event.
     * @param jsonObject
     * @param languages
     */
    deserialize(jsonObject, languages) {
        if (!jsonObject.version || (jsonObject.version === CategoricalChartModel.version)) {
            let categoricalChartReportModel = new categorical_chart_report_model_1.CategoricalChartReportModel();
            categoricalChartReportModel.deserialize(jsonObject.categoricalChartReportModel);
            this._categoricalChartReportModel = categoricalChartReportModel;
            let categoricalChartOptions = new categorical_chart_options_model_1.CategoricalChartOptions();
            categoricalChartOptions.deserialize(jsonObject.categoricalChartOptions, languages);
            this._categoricalChartOptions = categoricalChartOptions;
            this._filter = idm_reporting_service_client_js_1.FilterTreeDto.fromJson(jsonObject.filter);
            this._pages = jsonObject.pages == undefined ? null : jsonObject.pages;
        }
    }
    /**
     * Deserializes the categorical chart filter model from json object and emits change event.
     * @param jsonObject
     */
    deserializeModelWithFilter(jsonObject) {
        if (!jsonObject.version || (jsonObject.version === CategoricalChartModel.version)) {
            this._filter = idm_reporting_service_client_js_1.FilterTreeDto.fromJson(jsonObject.filter);
        }
    }
    /**
     * Deserializes the categorical chart model from json string.
     * When we have empty page with new chart control, state is equal to "" or null.
     * @param {string} categoricalChartModel
     * @param {Array<Language>} languages
     */
    fromJsonString(categoricalChartModel, languages) {
        if (categoricalChartModel !== "" && categoricalChartModel !== null) {
            let stateJsonObject = JSON.parse(categoricalChartModel);
            this.deserialize(stateJsonObject, languages);
        }
    }
    /**
     * Deserialize the categorical chart model filter from json string.
     * When we have empty page with new chart control, state is equal to "" or null.
     * @param categoricalChartModel
     */
    chartWithFilterFromJsonString(categoricalChartModel) {
        if (categoricalChartModel !== "" && categoricalChartModel !== null) {
            let stateJsonObject = JSON.parse(categoricalChartModel);
            this.deserializeModelWithFilter(stateJsonObject);
        }
    }
    toJsonString(languages) {
        return JSON.stringify(this.serialize(languages));
    }
    getCategoricalChartModel() {
        return this.categoricalChartModel;
    }
}
CategoricalChartModel.version = "0.0.1";
exports.CategoricalChartModel = CategoricalChartModel;
//# sourceMappingURL=categorical-chart.model.js.map